// const REPORT_URL= "https://beautyapi.winayak.com"
const REPORT_URL = "https://apps.grademybeauty.com"

export default {
    REPORT_URL: REPORT_URL
}